import { render, staticRenderFns } from "./UgcSubmissionEdit.vue?vue&type=template&id=e358a9ec"
import script from "./UgcSubmissionEdit.vue?vue&type=script&lang=js"
export * from "./UgcSubmissionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports